import Conversations from './Conversations.vue';
import ChatView from './ChatView.vue';

const routes = [
	{
		path: '/communication',
		name: 'communication.conversations',
		component: Conversations,
	},
	{
		path: '/communication/:uuid',
		name: 'communication.chat',
		component: ChatView,
		props: true,
	},
];

export default routes;
